import type { EnumValue } from "@productlane/lib"

import type { SchemaField } from "../model/tool-schema-fields"
import { FieldNotice } from "../inputs/field-notice"
import { ScalarTokenField } from "../inputs/scalar-token-field"
import { valueKind } from "../model/typed-value"

export function EnumEditor({
	field,
	values,
	onChange,
}: {
	field: SchemaField
	values: EnumValue[]
	onChange: (values: EnumValue[]) => void
}) {
	// The declared values decide the type, so a numeric enum cannot be filled with
	// strings that would intersect to nothing and hide the whole tool.
	const itemKinds = field.enumValues?.length
		? [valueKind(field.enumValues[0]!)]
		: field.kinds

	const declared = field.enumValues ?? []
	const impossible =
		declared.length > 0 &&
		values.length > 0 &&
		!values.some((value) => declared.includes(value))

	return (
		<div className="mt-1.5 space-y-1.5">
			<ScalarTokenField
				name={`enum-${field.path}`}
				values={values}
				itemKinds={itemKinds}
				suggestions={declared}
				emptyHint="With no values listed the agent cannot pass this argument at all."
				onChange={onChange}
			/>
			{impossible ? (
				<FieldNotice tone="error" className="mt-0">
					None of these values is one this tool accepts, so the agent cannot use
					it at all.
				</FieldNotice>
			) : null}
		</div>
	)
}
